/// <amd-module name="WorkItemsHub/Components/Cells/WorkItemIconTitleCell" />

import * as React from "react";
import * as UrlUtils from "WorkItemsHub/Utils/UrlUtils";
import { Link } from "VSSUI/Link";
import { OnOpenWorkItemHandler } from 'Utils/NavigationUtils';
import { IVssPageContext } from 'VSS/Platform/Context';
import { WorkItemTypeIcon } from "Wit/UI/WorkItemTypeIcon";
import { WorkItemTypeColorAndIcon } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { UsageTelemetryHelper } from "WorkItemsHub/Utils/Telemetry";

export interface ITitleCellOptions {
    workItemId: number;
    workItemTitle: string;
    workItemType: string;
    projectName: string;
    onOpenWorkItem: OnOpenWorkItemHandler;
    icon: WorkItemTypeColorAndIcon;
}

export function createWorkItemIconTitleCell(pageContext: IVssPageContext, options: ITitleCellOptions): JSX.Element {
    const onTitleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        options.onOpenWorkItem(options.workItemId, e);
        UsageTelemetryHelper.publishClickOnWorkItem(pageContext, options.workItemId);
    }
    // Important: when changing the structure and CSS for this cell, make sure to test for accessibility borders
    return (
        <div className="work-item-icon-title-cell">
            <WorkItemTypeIcon data={options.icon} />
            <div className="work-item-title">
                <Link
                    className="work-item-title-link"
                    href={UrlUtils.getEditWorkItemUrl(pageContext, options.projectName, options.workItemId)}
                    onClick={onTitleClick}
                    tooltipProps={{
                        className: "work-item-title-tooltiphost",
                        overflowOnly: true,
                        showOnFocus: true,
                        text: options.workItemTitle
                    }}
                    removeUnderline={true}
                >
                    {options.workItemTitle}
                </Link>
            </div>
        </div>
    );

};
